"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoCurrentDataInfo = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var NoCurrentDataInfo = function (_a) {
    var _b;
    var isTraditional = _a.isTraditional, datePeriod = _a.datePeriod;
    var _c = (0, core_1.useComponents)(), InfoNotification = _c.InfoNotification, Heading2 = _c.Heading2;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _d.copy, Copy = _d.Copy;
    var getTitleCopy = function () {
        switch (datePeriod) {
            case 'daily':
                return copy('noCurrentDataInfoTitleDay');
            case 'monthly':
                return copy('noCurrentDataInfoTitleMonth');
            case 'yearly':
            default:
                return copy('noCurrentDataInfoTitleYear');
        }
    };
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.USAGE_NO_CURRENT_DATA_INFO, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(InfoNotification, { noMargin: true, "data-testid": "usage-no-current-data-info", id: "usage-no-current-data-info" },
            react_1.default.createElement(Heading2, null, getTitleCopy()),
            isTraditional ? (react_1.default.createElement(Copy, { copyKey: "noCurrentDataInfoTradBody" })) : (react_1.default.createElement(Copy, { copyKey: "noCurrentDataInfoBody" })))));
};
exports.NoCurrentDataInfo = NoCurrentDataInfo;
